export default __webpack_public_path__ + "static/media/uploader-oneTouchUltra2-problem-2.af80c60a.png";